import qs from 'qs'
import axios from '~/utils/axios'

export default {
  get(url, data, config = {}) {
    return axios.get(url, {
      ...config,
      params: data,
      // 处理get有重复参数的场景，
      // 从原来的 id[]: id1; id[]: id2；（名称多了一个[]）
      // 转为id: id1; id: id2（后台接受第一个）；
      paramsSerializer: params => {
        return params ? qs.stringify(params, { indices: false }) : params
      }
    })
  },

  post(url, data, config) {
    return axios.post(url, data, config)
  },
  delete(url, data, config) {
    return axios.delete(url, data, config)
  },
  put(url, data, config) {
    return axios.put(url, data, config)
  },
  postForm(url, data, config = {}) {
    return axios.post(url, qs.stringify(data), {
      ...config,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  axios
}
